import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Ridicare',
  [OrderMethod.Delivery]: 'Livrare',
  [OrderMethod.OnSite]: 'La masă',
};
